@for (badge of inputBadges; track badge) {
  <app-badge
    [message]="badge"
    [color]="'primary'"
  ></app-badge>
}
